import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantCashTransferServiceService,
  ParticipantCashTransferServiceSharedService,
} from '../../services/wealthlane-award-settlement-services';

const useGetCashTransferStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const cashTransferStatus = useQuery(
    ['getCashTransferStatus'],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceSharedService.getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return cashTransferStatus;
};

export default useGetCashTransferStatus;
